
const mutations = {
    setLoginUrl(state, data) {
        state.jumpUrl = data;
        console.log('state.jumpUrl', state.jumpUrl)
    },
    setDialogMutations(state, data) {
        state.dialogData = data;
    },
    dialogTypeMutations(state, data) {
        state.dialogType = data;
    },
    // fullscreenLoading
    fullscreenLoadingMutations(state, data) {
        state.fullscreenLoading = data
    },
    setLoginMutations(state, data) {
        state.login = data
    },
    setJoinMutations(state, data) {
        state.join = data
    },
    changeUserInfo (state, value) {
        state.userInfo = value
    },
    // 更改搜索条件
    changeSearchCondition(state, obj) {
        state.searchCondition[obj.key] = obj.value
    },
    changeSearchVal(state, data) {
        state.searchVal = data
    },
    // 重置搜索条件
    reSetSearchCondition(state) {
        state.searchCondition = {
            cateId: '',
            ext1: "",
            isTrainingCamp: '',
            name: "",
            pageNum: 1,
            pageSize: 12,
            sellerId: "",
            sortByHot: 0,
            sortByNew: 1
        }
    },
    changeResetFlag(state, data) {
        state.isReset = data
    },
    // 更改列表
    changeList(state, data) {
        state.list = data
    },
    // 更改分页信息
    changePageInfo(state, data) {
        state.pageInfo = data
    },
    // 登录状态
    changeLoginInfo(state, data) {
        state.loginInfo = data
    }
}
export default mutations
